/*global jQuery */
(function ($, window, document, undefined) {
  'use strict';
  let scrollTop,
    offsetTriggerY = 140,
    $window,
    $document,
    $docElement,
    isScrolled,
    isScrollingUp,
    lastScrollTop,


    update = function()
    {
      scrollTop = Math.round($window.scrollTop());

      if(scrollTop > offsetTriggerY)
      {
        if(!isScrolled) {
          isScrolled = true;

          $docElement.removeClass('is-noScroll');
          $docElement.addClass('is-scroll');
        }
      }
      else {
        if( isScrolled ) {
          isScrolled = false;

          $docElement.addClass('is-noScroll');
          $docElement.removeClass('is-scroll');
        }
      }

      if (scrollTop > lastScrollTop || scrollTop === 0) {
        if(isScrollingUp) {
          isScrollingUp = false;

          $docElement.removeClass('is-scrollTop');
        }
      }
      else {
        if( ! isScrollingUp ) {
          isScrollingUp = true;
          $docElement.addClass('is-scrollTop');
        }
      }

      lastScrollTop = scrollTop;
    },


    init = function(){
      $window = $(window);
      $document = $(document);
      $docElement = $(document.documentElement);

      isScrolled = false;
      isScrollingUp = false;
      lastScrollTop = Math.round($window.scrollTop());

      $window.on('orientationchange resize scroll load', function () {
        update();
      });

      $docElement.addClass('is-noScroll');
      update();
    };


  init();

})(jQuery, window, document);
